module.exports = __webpack_public_path__ + "img/3x.e97f913.jpg";